// export const BASEURL = "http://localhost:8081";
// export const BASEURL = "http://192.168.1.71:8081";
export const BASEURL = "https://dev.officefinder.ai";
// export const BASEURL = "http://192.168.1.71:8080";
export const WEBHOOK_URL =
  "https://hook.eu1.make.com/rxs7wa2tuohqujra6682hoaufgtny9s5";

export const CRPTO_SECRET_KEY = "AK!@gfkunnu12345adcu878786o/565eAK";
export const GOOGLE_CLIENT_ID =
  "1034888974578-doaqtggiuuoija9p8isps2pu0qn8ln5u.apps.googleusercontent.com";

export const AUTH_BASE = "/api/auth";
export const PROPERTY_BASE = "/api/property";

// ENDPOINTS FOR AUTH MODULE
export const AUTH_ENDPOINT = {
  GOOGLE_LOGIN: `${AUTH_BASE}/google-login`,
  LOGIN: `${AUTH_BASE}/login`,
  SINGUP: `${AUTH_BASE}/sign-up`,
  OTP_VERIFICATION: `${AUTH_BASE}/otp-verification`,
  RESEND_OTP: `${AUTH_BASE}/resend-otp`,
  TEST: `${AUTH_BASE}/test`,
  FORGOT_PASSWORD: `${AUTH_BASE}/forgot-password`,
  RESET_PASSWORD: `${AUTH_BASE}/reset-password`,
  CHANGE_PASSWORD: `${AUTH_BASE}/change-password`,
  ACCOUNT_DELETE: `${AUTH_BASE}/delete-account`,
  CONTACTUS: `${AUTH_BASE}/contact-us`,
};

// ENDPOINTS FOR PROPERTY MODULE
export const PROPERTY_ENDPOINT = {
  FILTER_PROPERTY: `${PROPERTY_BASE}/filter-property`,
  FILTER_PROPERTY_LIST: `${PROPERTY_BASE}/filter-property-list`,
  BUDGET_PRICING_SUGGESTION: `${PROPERTY_BASE}/budget-pricing-suggestion`,
  CHAT_HISTORY_TITLE: `${PROPERTY_BASE}/chat-history-list`,
  CHAT_HISTORY_DETAILs: `${PROPERTY_BASE}/chat-history-details`,
  WEBHHOOK_REQUEST: `${PROPERTY_BASE}/webhook/send-request`,
};
